import { timeline } from "@/mocks/blackMaterial";

const toneDot: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-400",
};

const toneTag: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-200/70 text-foreground-600",
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-3">
          <span className="text-xs font-semibold tracking-[0.18em] text-accent-600">塌房人物 · 事件推进</span>
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">争议事件时间线</h2>
          <p className="max-w-2xl text-sm leading-7 text-foreground-500">
            一条条争议如何从零到热、再到反转或凉透？按日期回放推进节点，看得见事件的完整坡度。
          </p>
        </div>

        <div className="relative mt-10">
          <div className="absolute bottom-2 left-[7px] top-2 w-px bg-background-300 md:left-1/2" />
          <div className="space-y-8">
            {timeline.map((e) => (
              <div key={e.date + e.title} className="relative grid gap-3 md:grid-cols-2 md:gap-10">
                <div className="flex items-center md:justify-end">
                  <div className="text-right">
                    <div className="text-sm font-semibold text-foreground-800">{e.date}</div>
                    <div className={`mt-1 inline-block whitespace-nowrap rounded-md px-2 py-0.5 text-[11px] ${toneTag[e.tone]}`}>
                      {e.tag}
                    </div>
                  </div>
                </div>
                <div className="flex gap-4">
                  <span className="mt-1 flex w-4 shrink-0 justify-center">
                    <span className={`mt-1 h-3.5 w-3.5 rounded-full ring-4 ring-background-100 ${toneDot[e.tone]}`} />
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950">{e.title}</h3>
                    <p className="mt-1 max-w-md text-xs leading-5 text-foreground-500">{e.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}